import type { ReactElement } from 'react'

import { RelatedDocumentLinks } from '@features/invoices/elements/RelatedDocumentLinks'

import { useQuoteRelatedInvoices } from './hooks/useQuoteRelatedInvoices'

export const QuoteRelatedInvoices = (): ReactElement => {
  const relatedInvoices = useQuoteRelatedInvoices()

  return <RelatedDocumentLinks relatedDocuments={relatedInvoices} />
}
